import { useMutation, UseMutationResult } from 'react-query'
import { localConfig } from '../../../../Configs/localConfig'
import { errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'
import { api } from '../../../api'

interface ParamsDeleteVariedade {
    cod_usuario: number
    cod_veiculo: number
    refetch_deletar: Function
}

export const useDeleteAtribuicaoFrota = (): {
    carregando_deletar_atribuicao: boolean
    mutate_deletar_atribuicao: (params: ParamsDeleteVariedade) => void
} => {
    const mutation: UseMutationResult<Response, Error, ParamsDeleteVariedade> = useMutation(
        async (params: ParamsDeleteVariedade) => {
            const { cod_usuario, cod_veiculo, refetch_deletar } = params

            loadingAlert({ msg: 'Excluindo...', id: 'delete_atribuicao' })

            return api
                .delete(
                    `/usuario/${cod_usuario}/veiculo/${cod_veiculo}?codConta=${localConfig()?.conta
                    }&codCliente=${localConfig()?.codCliente}`
                )
                .then((response: any) => {
                    successAlert('Excluído com sucesso!', 5000, 'delete_atribuicao')
                    refetch_deletar?.()
                    return response
                })
                .catch((error: Error) => {
                    //@ts-ignore
                    let error_response = error?.response?.data
                    errorAlert(
                        error_response?.error ?? 'Falha ao excluir atribuicao',
                        5000,
                        'delete_atribuicao'
                    )

                    throw error
                })
        }
    )

    return {
        carregando_deletar_atribuicao: mutation.isLoading,
        mutate_deletar_atribuicao: mutation.mutate,
    }
}